// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"338":"2328a75f7bfd0cc4","448":"4a16e80997f8886f"}[chunkId] + ".js";
};